import { Component, OnInit } from '@angular/core';
import { DrI18nService, DrLocales } from '@app/core/services/i18n/i18n.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public readonly smp360Locales = {
    DE: DrLocales.DE,
    EN: DrLocales.EN
  };

  public locale: DrLocales;

  constructor(private drI18nService: DrI18nService) {

  }

  ngOnInit() {
    this.locale = this.drI18nService.activeLocale;
  }

  public updateLocale(locale: DrLocales): void {
    this.locale = locale;
    this.drI18nService.activeLocale = locale;
  }
}
